import { LoginCallback } from '@okta/okta-react';
import { Route, Switch, Redirect } from 'react-router-dom';

import { App } from 'App';
import { Authentication } from 'pages/authentication';

export const PortalRoutes = () => {
  return (
    <Switch>
      <Route exact path='/' component={Authentication} />
      <Route path='/home' component={App} />
      <Route path='/login/callback' component={LoginCallback} />

      <Route path='/*' component={() => <Redirect to='/' />} />
    </Switch>
  );
};
